import { ErrorType, TaskError } from '@nexelem/graphne-api';

export const hasOverdueError = (errors: TaskError[] = []): boolean =>
  errors.map(({ errorType }) => errorType).some((errorType) => errorType === ErrorType.Overdue);
